import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function CookiePolicy() {
  const { t } = useTranslation('cookie');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8">
          {t('title')}
        </h1>

        <div className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('intro.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('intro.text')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('whatAreCookies.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('whatAreCookies.text')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('cookiesWeUse.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('cookiesWeUse.intro')}
            </p>
            
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mb-4">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {t('cookiesWeUse.necessary.title')}
              </h3>
              <p className="text-slate-700 mb-3 leading-relaxed">
                {t('cookiesWeUse.necessary.description')}
              </p>
              <p className="text-slate-700 leading-relaxed">
                <strong>{t('cookiesWeUse.necessary.examplesLabel')}</strong> {t('cookiesWeUse.necessary.examples')}
              </p>
            </div>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {t('cookiesWeUse.noTracking.title')}
              </h3>
              <p className="text-slate-700 leading-relaxed">
                {t('cookiesWeUse.noTracking.description')}
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('futureTracking.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('futureTracking.text')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('manageCookies.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('manageCookies.intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 text-slate-700 ml-4">
              <li>{t('manageCookies.browsers.chrome')}</li>
              <li>{t('manageCookies.browsers.firefox')}</li>
              <li>{t('manageCookies.browsers.safari')}</li>
              <li>{t('manageCookies.browsers.edge')}</li>
            </ul>
            <p className="text-slate-700 mt-4 leading-relaxed">
              {t('manageCookies.warning')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('updates.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('updates.text')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('contact.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('contact.intro')}
            </p>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
              <p className="text-slate-900 font-semibold mb-2">NovaVenture Group BV</p>
              <p className="text-slate-700">Krommestraat 48</p>
              <p className="text-slate-700">2830 Blaasveld, België</p>
              <p className="text-slate-700 mt-3">
                <strong>BTW:</strong> BE1006303437
              </p>
              <p className="text-slate-700">
                <strong>E-mail:</strong>{' '}
                <a href="mailto:David@novaventure.be" className="text-teal-600 hover:text-teal-700 transition-colors">
                  David@novaventure.be
                </a>
              </p>
              <p className="text-slate-700">
                <strong>Tel:</strong>{' '}
                <a href="tel:+32488139664" className="text-teal-600 hover:text-teal-700 transition-colors">
                  +32 488 13 96 64
                </a>
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">
              {t('moreInfo.title')}
            </h2>
            <p className="text-slate-700 mb-4 leading-relaxed">
              {t('moreInfo.intro')}
            </p>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-teal-600 hover:text-teal-700 transition-colors font-medium"
                >
                  {t('moreInfo.privacyLink')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-service" 
                  className="text-teal-600 hover:text-teal-700 transition-colors font-medium"
                >
                  {t('moreInfo.termsLink')}
                </Link>
              </li>
            </ul>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600">
              {t('lastUpdated')}
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}